module.exports = __webpack_public_path__ + "static/media/profile-picture-3.99bad376.jpg";